import React, { useCallback, useEffect } from 'react'
import { Input, Form, Select, Button, Tooltip, Switch } from 'antd'
import { shopLogClstag } from '../shop/log'
import Cascader from '@zero/multiple-caseader'
import { erpLogClstag } from '../erp/log'
import { QuestionCircleOutlined } from '@ant-design/icons'

const { Option } = Select

interface Props {
  contorlItems?: Items[]
  type: string
  searchMaxWidth: number
  onChange?: (e: any) => void
  spuFlow: number
  showSkuFilter?: boolean
}

interface Items {
  name: string | JSX.Element
  code: string
  dataType: number // 1 是输入框  2是图片 3是类目 4是checkbox 5是select
  width?: number
  placeholder?: string
  initialValue?: boolean
  // labelCol?: Col
  // wrapperCol?: Col
  options?: Options[]
  checked?: boolean
  vaildate?: (e: string, val: string) => Promise<any>
  style?: any
}

interface Col {
  [key: string]: any // 参考 https://ant.design/components/grid-cn/#Col
}
interface Options {
  value: string | number
  clstag?: string
  label: string
}

const Search = (props: Props) => {
  const { onChange = () => {}, contorlItems = [], type = 'shop', spuFlow, showSkuFilter = true } = props
  const [form] = Form.useForm()

  useEffect(() => {
    form.resetFields()
  }, [contorlItems])

  const proTypeNode = (item) => {
    if (item.code === 'skuQueryType') {
      return (
        <div>
          {item.name}
          <Tooltip title="可根据商品类型去筛选该活动下的对应商品">
            <QuestionCircleOutlined style={{ marginLeft: 2 }} />
          </Tooltip>
        </div>
      )
    } else {
      return <div>{item.name}</div>
    }
  }

  const formItem = useCallback(
    (item, children) => (
      <Form.Item
        initialValue={item.initialValue}
        style={{ width: item.width ? item.width : 'auto', marginBottom: 10 }}
        label={proTypeNode(item)}
        name={item.code}
        key={item.code}
      >
        {children}
      </Form.Item>
    ),
    [contorlItems]
  )
  const onSubmit =(e) => {
    if (e.categoryThirdIds && e.categoryThirdIds.length) {
      e.categoryThirdIds = type === 'shop' ? e.categoryThirdIds.join(',') : e.categoryThirdIds.map((i) => +i)
    }
    onChange(e)
  }

  const onReset = () => {
    form.resetFields()
    onChange(form.getFieldsValue())
  }
  return (
    <div style={{ maxWidth: props.searchMaxWidth || 'none' }}>
      {Boolean(contorlItems.length) && (
        <Form layout="inline" onFinish={onSubmit} form={form}>
          {contorlItems.map((item) => {
            switch (item.dataType) {
              case 1:
                return formItem(item, <Input placeholder={item.placeholder} />)
              case 2:
                return formItem(
                  item,
                  <Input.Group compact>
                    <Form.Item name={['goods', 'goodsType']} noStyle>
                      <Select defaultValue="2" style={{ width: '71px' }}>
                        {showSkuFilter && <Option value="2">SKU</Option>}
                        {spuFlow && <Option value="1">SPU</Option>}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name={['goods', 'goodsId']}
                      noStyle
                      rules={[
                        {
                          validator: async (_, value) => {
                            if (value && isNaN(value)) {
                              return Promise.reject(new Error('请输入正确的商品ID格式'))
                            }
                          },
                        },
                      ]}
                    >
                      <Input style={{ width: '130px' }} placeholder="请输入" />
                    </Form.Item>
                  </Input.Group>
                )
              case 3:
                const categoryTreeProps = {
                  options: item.options,
                  placeholder: '请选择',
                  getPopupContainer: (triggerNode) => triggerNode.parentNode || document.body,
                  fieldNames: { label: 'name', value: 'id' },
                }
                return formItem(item, <Cascader {...categoryTreeProps} />)
              case 4:
                return formItem(
                  item,
                  <Switch
                    defaultChecked={item.initialValue}
                    onChange={() => {
                      form.submit()
                    }}
                    clstag={type === 'shop' ? shopLogClstag['mainGoodBtnClick'] : erpLogClstag['mainGoodBtnClick']}
                  />
                )
              case 5:
                return formItem(
                  item,
                  <Select
                    placeholder={item.placeholder}
                    onChange={(e) => {
                      const filterList = item.options.filter((i) => i.value === e)
                      if (item.options && filterList.length && filterList[0].clstag) {
                        window.log(filterList[0].clstag)
                      }
                    }}
                    style={item.style || {}}
                    dropdownMatchSelectWidth={false}
                  >
                    {item.options.map((i) => (
                      <Option value={i.value} key={i.value}>
                        <span clstag={i.clstag ? i.clstag : ''}>{i.label}</span>
                      </Option>
                    ))}
                  </Select>
                )
              default:
                return formItem(item, <Input />)
            }
          })}
          <Form.Item>
            <Button
              type="primary"
              ghost
              htmlType="submit"
              style={{ marginRight: -8, borderRadius: 40 }}
              clstag={type === 'shop' ? shopLogClstag['searchBtnClick'] : erpLogClstag['searchBtnClick']}
            >
              查询
            </Button>
          </Form.Item>
          <Form.Item>
            <Button htmlType="button" onClick={onReset} style={{ marginRight: 0, borderRadius: 40 }}>
              重置
            </Button>
          </Form.Item>
        </Form>
      )}
    </div>
  )
}

export default Search
